import EmptyState from '@rio-cloud/rio-uikit/EmptyState';
import ErrorState from '@rio-cloud/rio-uikit/ErrorState';
import ForbiddenState from '@rio-cloud/rio-uikit/ForbiddenState';
import { FormattedMessage, useIntl } from 'react-intl';

import { CONTACT_FORM_TARGET_URL } from '../../common/popupService';
import { getLocalizedOpenMarketplaceLink } from '../../config/productConfig';

export function BookingOverviewEmptyState() {
    const { locale } = useIntl();

    return (
        <EmptyState
            headline={<FormattedMessage id='intl-msg:marketplace.myServices.empty.headline' />}
            message={<FormattedMessage id='intl-msg:marketplace.myServices.empty' />}
            buttons={[
                {
                    text: (
                        <span>
                            <span className='uikit-icon icon-shopping-cart' aria-hidden='true' />
                            <FormattedMessage id='intl-msg:marketplace.exploreServices' />
                        </span>
                    ),
                    href: getLocalizedOpenMarketplaceLink(locale),
                },
            ]}
            outerClassName='margin-top-20'
        />
    );
}

export function BookingOverviewErrorState({ onReload }: { onReload: () => void }) {
    return (
        <ErrorState
            headline={<FormattedMessage id='intl-msg:marketplace.bookings.overview.error.headline' />}
            message={
                <FormattedMessage
                    id='intl-msg:marketplace.bookings.overview.error.message'
                    values={{
                        link: chunks => (
                            <a href={CONTACT_FORM_TARGET_URL} target='_blank' rel='noreferrer'>
                                {chunks}
                            </a>
                        ),
                    }}
                />
            }
            buttons={[
                {
                    text: <FormattedMessage id='intl-msg:marketplace.error.button.reload' />,
                    onClick: onReload,
                },
            ]}
            outerClassName='margin-top-20'
        />
    );
}

export function BookingOverviewForbiddenState() {
    return (
        <ForbiddenState
            headline={<FormattedMessage id='intl-msg:marketplace.bookings.overview.forbidden.headline' />}
            message={<FormattedMessage id='intl-msg:marketplace.bookings.overview.forbidden.message' />}
            outerClassName='margin-top-20'
        />
    );
}
